export class FemurAnalyzerAPConfig {
}
FemurAnalyzerAPConfig.GT_color = 0x63ADF2;
FemurAnalyzerAPConfig.FH_color = 0x63ADF2;
FemurAnalyzerAPConfig.LE_color = 0x63ADF2;
FemurAnalyzerAPConfig.ME_color = 0x63ADF2;
FemurAnalyzerAPConfig.NS_color = 0x63ADF2;
FemurAnalyzerAPConfig.CE_color = 0x63ADF2;
FemurAnalyzerAPConfig.ACE_color = 0x63ADF2;
FemurAnalyzerAPConfig.apex_color = 0xFF0000;
FemurAnalyzerAPConfig.anatomicalAxis_color = 0xFFAC1E;
FemurAnalyzerAPConfig.GT_FH_Line_color = 0x63ADF2;
FemurAnalyzerAPConfig.FH_CE_Line_color = 0x63ADF2;
FemurAnalyzerAPConfig.LE_ME_Line_color = 0x63ADF2;
FemurAnalyzerAPConfig.proximalMechanicalAxis_color = 0xFFFF00;
FemurAnalyzerAPConfig.distalMechanicalAxis_color = 0xFFFF00;
FemurAnalyzerAPConfig.neckShaftAxis_color = 0xFFAC1E;
FemurAnalyzerAPConfig.LPFALabel_backgroundColor = 'rgba(0, 0, 0, 0.6)';
FemurAnalyzerAPConfig.LPFALabel_fontColor = '#ffffff';
FemurAnalyzerAPConfig.mLDFALabel_backgroundColor = 'rgba(0, 0, 0, 0.6)';
FemurAnalyzerAPConfig.mLDFALabel_fontColor = '#ffffff';
FemurAnalyzerAPConfig.apexLabel_backgroundColor = 'rgba(255, 255, 0, 0.6)';
FemurAnalyzerAPConfig.apexLabel_fontColor = '#ffffff';
FemurAnalyzerAPConfig.NS_FH_A_color = 0xFFAC1E;
FemurAnalyzerAPConfig.NS_FH_B_color = 0xFFAC1E;
FemurAnalyzerAPConfig.NS_FH_C_color = 0xFFAC1E;
FemurAnalyzerAPConfig.NS_GT_lower_A_color = 0xFFAC1E;
FemurAnalyzerAPConfig.NS_GT_lower_B_color = 0xFFAC1E;
FemurAnalyzerAPConfig.NS_GT_lower_C_color = 0xFFAC1E;
FemurAnalyzerAPConfig.NS_GT_upper_A_color = 0xFFAC1E;
FemurAnalyzerAPConfig.NS_GT_upper_B_color = 0xFFAC1E;
FemurAnalyzerAPConfig.NS_GT_upper_C_color = 0xFFAC1E;
FemurAnalyzerAPConfig.NS_FH_Line_color = 0xFFAC1E;
FemurAnalyzerAPConfig.NS_GT_lower_line_color = 0xFFAC1E;
FemurAnalyzerAPConfig.NS_GT_upper_line_color = 0xFFAC1E;
FemurAnalyzerAPConfig.MNSALabel_backgroundColor = 'rgba(0, 0, 0, 0.6)';
FemurAnalyzerAPConfig.MNSALabel_fontColor = '#ffffff';
//# sourceMappingURL=FemurAnalyzerAPConfig.js.map